import * as React from 'react';
import {Link, useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import companyLogo from '../logo.png';
import configData from '../services/config.json';

const liveurl = configData.LIVE_URL;
const resulturl = configData.RESULT_URL;
const eventid = configData.EVENT_ID;

var pages = [
  {'item':'Startlister','link':'/startlister'} ,
  {'item':'Resultater','link':'/resultater'}
  ];
if (configData.SHOW_AGENDA) {
  pages.push({'item':'Program','link':'/agenda'});
}
pages.push({'item':'Vis på MyLaps','link':'external','href':resulturl + '/events/' + eventid});

const PublicAppBar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const navigate = useNavigate();

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar position="static">
      <Container maxWidth="xl" disableGutters={true}>
        <Toolbar disableGutters={true}>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex' }, p: {xs: '10'} }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'block' },
              }}
            >
              {pages.map((page) => (
                page.href ? (
                  <MenuItem key={page.item} onClick={handleCloseNavMenu}>
                    <a href={page.href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit'}}>
                    <Typography textAlign="center">{page.item}</Typography>
                    </a>
                  </MenuItem>
                ) : (
                  <MenuItem key={page.item} onClick={handleCloseNavMenu} component={Link} to={page.link}>
                    <Typography textAlign="center">{page.item}</Typography>
                  </MenuItem>
                )
              ))}
            </Menu>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'none' } }}>
            {pages.map((page) => (
              <Button
                key={page.item}
                onClick={handleCloseNavMenu}
                component={Link} to={page.link}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page.item}
              </Button>
            ))}
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex' } }} >
          {liveurl && (
                <a id="liveButton" href={liveurl} target="_blank" style={{right:'10px', top:'10px'}}><img src="/live-streaming-icon.svg" width="30" align="right" style={{backgroundColor:'azure', border:'1px solid', borderColor:'darkred', padding:'5px'}}/></a>
              )}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default PublicAppBar;
